import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { Configuration } from '../types';

import { SecretQueryParams } from './types';
import { secretQueryKeys } from './query-keys';

export function useSecretsForCluster<TData = Configuration[]>(
  environmentId: EnvironmentId,
  options?: {
    autoRefreshRate?: number;
    select?: (data: Configuration[]) => TData;
    enabled?: boolean;
  } & SecretQueryParams
) {
  const { autoRefreshRate, select, enabled, ...params } = options ?? {};
  return useQuery(
    secretQueryKeys.secretsForCluster(environmentId, params),
    () => getSecrets(environmentId, params),
    {
      ...withError('Unable to retrieve secrets for cluster'),
      refetchInterval() {
        return autoRefreshRate ?? false;
      },
      select,
      enabled,
    }
  );
}

// get all secrets for a cluster
async function getSecrets(
  environmentId: EnvironmentId,
  params?: SecretQueryParams
) {
  try {
    const { data } = await axios.get<Configuration[]>(
      `/kubernetes/${environmentId}/secrets`,
      { params }
    );
    return data;
  } catch (e) {
    throw parseAxiosError(e, 'Unable to retrieve secrets');
  }
}
